"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const react_hook_form_1 = require("react-hook-form");
const react_select_1 = __importDefault(require("react-select"));
require("./index.scss");
const CellDropdown = ({ name, value, onSelectedValueChanged }) => {
    const { control } = (0, react_hook_form_1.useFormContext)();
    const { libStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const writerRoleOptions = libStore.writerRoles;
    const controllerDefaultValue = () => writerRoleOptions.find((option) => option.label === value);
    const configureStyle = (baseStyles, fieldError) => {
        const updatedStyles = Object.assign({}, baseStyles);
        updatedStyles.border = !fieldError ? '1px solid grey' : '2px solid red';
        updatedStyles.boxShadow = 'none';
        return updatedStyles;
    };
    const selectRef = (0, react_1.useRef)();
    return (react_1.default.createElement("div", { className: 'cell-dropdown-container' },
        react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, shouldUnregister: true, defaultValue: controllerDefaultValue(), render: ({ field, fieldState }) => {
                const { ref } = field, restOfFieldProps = __rest(field, ["ref"]);
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_select_1.default, Object.assign({ ref: (currentRef) => {
                            ref(currentRef);
                            selectRef.current = currentRef;
                        }, styles: {
                            control: (baseStyles) => configureStyle(baseStyles, fieldState.error),
                        }, menuPosition: 'fixed', className: 'select' }, restOfFieldProps, { options: writerRoleOptions, onChange: (e) => {
                            field.onChange(e);
                            onSelectedValueChanged(e);
                            selectRef.current && setTimeout(() => selectRef.current.blur());
                        }, placeholder: 'Select a role' })),
                    fieldState.error && react_1.default.createElement("span", { className: 'error-message' }, fieldState.error.message)));
            } })));
};
exports.default = CellDropdown;
